import React from 'react';
import CnNavBarView from './cn-nav-bar-view';
class CnNavBar extends React.Component {
    constructor(props) {
        super(props);
        this.ref = React.createRef();
    }
    render() {
        return React.createElement(CnNavBarView, { ref: this.ref, ...this.props });
    }
}
CnNavBar.displayName = 'CnNavBar';
export default CnNavBar;
export { CnNavBar };
